const messages = {
    en: {
        role: {
            permissions: {
                AFIP_MENU: "Access to AFIP",
                AFIP_SHOW: "View AFIP",
                AFIP_CREATE: "Create billing to AFIP",
                AFIP_UPDATE: "Modify AFIP",
                AFIP_DELETE: "Delete AFIP"
            }
        }
    },
    es: {
        role: {
            permissions: {
                AFIP_MENU: "Acceder a AFIP",
                AFIP_SHOW: "Ver AFIP",
                AFIP_CREATE: "Emitir factura AFIP",
                AFIP_UPDATE: "Modificar AFIP",
                AFIP_DELETE: "Eliminar AFIP"
            }
        }
    },
    pt: {
        role: {
            permissions: {
                AFIP_MENU: "Access to AFIP",
                AFIP_SHOW: "View AFIP",
                AFIP_CREATE: "Create billing to AFIP",
                AFIP_UPDATE: "Modify AFIP",
                AFIP_DELETE: "Delete AFIP"
            }
        }
    }
}

export default messages
